/**
 * available-data-exports-response.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { validateAs, validateFor, validateOpaqueID }
  from "../../validation/decorators";
import { IncomingMessage } from "../general/incoming-message";
import { MessageTag } from "../message-tag";

import { ExportFormatDescriptor } from "../../../aggregation/exporter";

@validateFor(MessageTag.RSP_AVAILABLE_DATA_EXPORTS)
export class AvailableDataExportsResponse extends IncomingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.RSP_AVAILABLE_DATA_EXPORTS;

  @validateAs({array: "object"}) // TODO: better validation
  public formats : ExportFormatDescriptor[];
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/export/available-data-exports-response.ts